<!--  -->
<template>
  <div class="left-menu">
    <a-menu
      mode="inline"
      :selectedKeys="selectedKeys"
      :openKeys="openKeys"
      :inline-collapsed="isCollapse"
      @openChange="onOpenChange"
      @click="menuClick"
    >
      <template v-for="item in menuList">
        <template v-if="item.meta.noLayout">
          <a-menu-item :key="item.path" :title="item.meta.title">
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="sunItemFirst.meta.title"
              placement="right"
            > -->
            <!-- <my-icon :type="sunItemFirst.meta.icon" /> -->
            <span class="anticon">
              <i :class="['iconfont', item.meta.icon]"></i>
            </span>
            <span>{{ item.meta.title }}</span>
          </a-menu-item>
        </template>

        <template v-else-if="item.meta.firstLevelMenu">
          <a-menu-item
            v-for="sunItemFirst in item.children"
            :key="sunItemFirst.path"
            :title="sunItemFirst.meta.title"
          >
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="sunItemFirst.meta.title"
              placement="right"
            > -->
            <!-- <my-icon :type="sunItemFirst.meta.icon" /> -->
            <span class="anticon">
              <i :class="['iconfont', sunItemFirst.meta.icon]"></i>
            </span>
            <span>{{ sunItemFirst.meta.title }}</span>
          </a-menu-item>
        </template>
        <sub-menu v-else :key="item.path" :menu-info="item" />
      </template>
    </a-menu>

    <i
      style="
        font-size: 20px;
        position: absolute;
        bottom: 10px;
        right: 10px;
        cursor: pointer;
      "
      :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
      @click="isCollapseFlag()"
    ></i>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Menu } from "ant-design-vue";
const SubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners"> 
        <span slot="title"> 
          <span class="anticon">
            <i :class="['iconfont',menuInfo.meta.icon]"></i> 
          </span>
          <el-tooltip class="item" effect="dark" :content="menuInfo.meta.title" placement="right-end"> 
            <span> {{ menuInfo.meta.title   }}  </span>
          </el-tooltip> 
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children" :key="item.path">
            <span class="anticon">
              <i :class="['iconfont',item.meta.icon]"></i> 
            </span>
            <span>{{ item.meta.title }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.path" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
  name: "SubMenu",
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
export default {
  name: "",
  //import引入的组件需要注入到对象中才能使用
  components: { "sub-menu": SubMenu },
  data() {
    //这里存放数据
    return {
      selectedKeys: [],
      openKeys: [],
      rootSubmenuKeys: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    menuList() {
      let getMenuList = JSON.parse(sessionStorage.getItem("getMenuList"));
      getMenuList.map((item) => {
        this.rootSubmenuKeys.push(item.path);
      });
      return getMenuList;
    },
    isCollapse() {
      return this.$store.state.isCollapse;
    },
    selectedMenu() {
      return this.$store.state.selectedMenu;
    },
  },
  //监控data中的数据变化
  watch: {
    $route: {
      handler(newVal) {
        this.selectedMenu
          ? (this.selectedKeys = [this.selectedMenu])
          : (this.selectedKeys = [this.$route.path]);
        // console.log(this.selectedMenu, 123);
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    isCollapseFlag() {
      this.$store.commit("isCollapseFlag", !this.isCollapse);
    },
    onOpenChange(openKeys) {
      // 将当前打开的父级菜单存入缓存中
      window.sessionStorage.setItem("openKeys", JSON.stringify(openKeys));
      //  控制只打开一个
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    menuClick(route) {
      // 获取到当前的key,并且跳转
      const { key } = route;

      this.$router.push({
        path: key,
      });
    },
    // ads(){
    //     this.isCollapse = !this.isCollapse
    // },
    showFlagFun(val) {
      debbugger;
      let permission = JSON.parse(sessionStorage.getItem("permission"));
      return this.checkRoutePermission(val, permission);
    },
    checkRoutePermission(to, permissionList) {
      var isValidate = false;
      if (to.meta.permissionPath) {
        isValidate = to.meta.permissionPath.some((item) =>
          permissionList.includes(item)
        );
      }
      return isValidate;
    },
    clearCheckData() {
      // this.$store.commit("getSelectData", this.multipleSelection);
      // this.$store.commit("getTableData", this.multipleSelection);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const openKeys = window.sessionStorage.getItem("openKeys");
    if (openKeys) {
      if (JSON.parse(openKeys).length > 0) {
        this.openKeys = [JSON.parse(openKeys)[JSON.parse(openKeys).length - 1]];
      } else {
        this.openKeys = JSON.parse(openKeys);
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.selectedMenu
      ? (this.selectedKeys = [this.selectedMenu])
      : (this.selectedKeys = [this.$route.path]);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss">
/* @import url(); 引入公共css类 */
@import url("../assets/css/leftMenu/left.css");

.ant-menu {
  &:not(.ant-menu-inline-collapsed) {
    width: 208px;
    // margin-right: 20px;
    // margin-left: 20px;
  }
}

.el-menu--vertical {
  display: block;
  background-color: rgba(45, 51, 62, 0.1);
  border-radius: 10px;
}

// 修改鼠标悬浮样式
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  background: #e6f7ff !important;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border: none !important;
}

.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border-right: 4px solid #1890ff !important;
}
</style>